import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useRecoilState } from "recoil";
import { carrierMetricPerState } from "../atom/atoms";
import { ICarrierMetricsPerState } from "../types";
import CarrierMetrics from "./CarrierMetrics";

interface CarrierMetricsPerStateProps {
  carrierMetricsPerState?: Array<ICarrierMetricsPerState>;
}

const CarrierMetricsPerState = ({
  carrierMetricsPerState,
}: CarrierMetricsPerStateProps): JSX.Element => {
  const [metricsPerState] = useRecoilState<Array<ICarrierMetricsPerState>[]>(
    carrierMetricPerState
  );
  return (
    <div className="mt-2 bg-white box-shadow rounded-lg h-full pb-4">
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${
                  open ? "transform rotate-90" : ""
                } w-5 h-5 text-gray-500`}
              />
              <div className="disclosureLabel text-sm ml-2">
                {"Carrier Metrics Per State"}
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="">
              {metricsPerState.length > 0 &&
                metricsPerState.map((metrics, i) => {
                  return (
                    <div key={i}>
                      <CarrierMetrics carrierMetrics={metrics} />
                    </div>
                  );
                })}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default CarrierMetricsPerState;
